import * as z from "zod";
const errorMapping = {
    email_empty: "login.email_empty",
    email_invalid: "login.email_invalid",
};

export const emailValidatorSchema = z.object({
    email: z
        .string({
            required_error: errorMapping.email_empty,
        })
        .min(1, {
            message: errorMapping.email_empty,
        })
        .regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, {
            message: errorMapping.email_invalid,
        }),
});

export type EmailValidatorSchema = z.infer<typeof emailValidatorSchema>;
